/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  StringMatch,
  StringMatch$inboundSchema,
  StringMatch$Outbound,
  StringMatch$outboundSchema,
} from "./stringmatch.js";

/**
 * Matches a named request field (header or query parameter). Exactly one of
 *
 * @remarks
 * `present` or `value` must be set.
 */
export type FieldMatch = {
  name: string;
  /**
   * Matches when the field is present, regardless of value.
   */
  present?: true | undefined;
  /**
   * String matcher. Exactly one of `exact`, `prefix` or `regex` must be set.
   */
  value?: StringMatch | undefined;
};

/** @internal */
export const FieldMatch$inboundSchema: z.ZodType<
  FieldMatch,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  present: z.literal(true).optional(),
  value: StringMatch$inboundSchema.optional(),
});
/** @internal */
export type FieldMatch$Outbound = {
  name: string;
  present?: true | undefined;
  value?: StringMatch$Outbound | undefined;
};

/** @internal */
export const FieldMatch$outboundSchema: z.ZodType<
  FieldMatch$Outbound,
  z.ZodTypeDef,
  FieldMatch
> = z.object({
  name: z.string(),
  present: z.literal(true).optional(),
  value: StringMatch$outboundSchema.optional(),
});

export function fieldMatchToJSON(fieldMatch: FieldMatch): string {
  return JSON.stringify(FieldMatch$outboundSchema.parse(fieldMatch));
}
export function fieldMatchFromJSON(
  jsonString: string,
): SafeParseResult<FieldMatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FieldMatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FieldMatch' from JSON`,
  );
}
